"use strict";

import { ListAnalytic } from "../analytics/ListAnalytics";
import { ListAnalyticV1 } from "../analytics/ListAnalyticsV1";
import { analyticsService } from "../analytics/AnalitycsService";

window.app.controller("controller", controller);

controller.$inject = [
  "$scope",
  "$http",
  "$timeout",
  "localStorageService",
  "$filter",
];

function controller($scope, $http, $timeout, localStorageService, $filter) {
  let vm = this;
  let _response = {};
  let map = null;
  let _distance;
  let origin;
  let destination;
  let id_map;
  let filter = [];
  let transportEmail = {};
  let config = window.__mt.setting;

  window.map_load = window.map_load || false;
  window.__mt.list = {};

  vm.lists = window.__mt.squeletons.list || [];
  vm.mobile = window.__mt.fn.mobileAndTabletCheck();
  vm.loading = true;
  vm.showMap = false;
  vm.filters = false;
  vm.no_results = false;
  vm.no_results_service = false;
  vm.no_results_availability = false;
  vm.no_result_next_date = false;
  vm.no_result_next_url = false;
  vm.mobile = window.__mt.fn.mobileAndTabletCheck();
  vm.ln = window.__mt.ln;
  vm.convertion = window.__mt.setting.exchange.convertion;
  vm.rountrip = 1;
  vm.showNoResultsMap = false;
  vm.box = null;
  vm.destinationName = "";
  vm.dateRange = "";
  vm.filters = {};
  vm.distance = {
    duration: {
      value: 0,
    },
    distance: {
      value: 0,
    },
  };
  vm.copy = false;
  vm.filter_setting = {
    price: {},
    passengers: {},
    suitcases: {},
  };
  vm.showSearchModal = false;
  vm.pageSize = 10;
  vm.currentPage = 1;
  vm.filtersApplied = {
    price: false,
    passengers: false,
    suitcases: false,
    extras: false,
    sort: false,
    pack: false,
    pax: false,
  };
  vm.hasActiveFilters = false;
  vm.dispositionPack = null;
  vm.dispositionPax = null;
  vm.dispositionPaxOptions = [2, 3, 4, 6, 8, 12, 14];
  vm.dispositionPackOptions = ['Normal', 'Premium', 'Business'];
  vm.sliders = null;
  vm.activeInfoTooltip = null;

  vm.init = function() {
    if (isValidRequest()) {
      setText();
      getTransports();
    } else {
      vm.loading = false;
      vm.lists = [];
      vm.no_results = true;
      goNoResults();
    }
  };

  vm.initMap = function() {
    vm.showMap = !vm.showMap;
    id_map = document.getElementById("map");
    $("#c-map").show();
    if (!map && !window.google) {
      window.__mt.fn.getScript(window.__mt.setting.google_map, {}, onLoadMap);
    } else {
      onLoadMap();
    }
  };

  vm.initFilter = function() {
    vm.filters = !vm.filters;
  };

  vm.checkout = function(item, l_index) {
    GoogleAddToCart(item, l_index);

    vm.loading = true;
    var session = {
      session: _response.response.sessionId,
      transports: [],
    };

    localStorageService.set("checkout", item);
    localStorageService.set("quote", window.__mt.setting.box);
    localStorageService.set("session", session);

    location.href = window.__mt.setting.checkout_page;
  };

  vm.calculateDelayTime = function(list) {
    var time_google =
      vm.distance && vm.distance.duration ? vm.distance.duration.value || 0 : 0;
    var time_transport = 0; //list.delayTime || 0;
    var time = (time_google + time_transport * 60) / 60;
    return time;
  };

  vm.addExtra = function(item) {
    //item.active = !item.active;

    if (item.active) {
      filter.push(item.extraId);
    } else {
      var index = filter.indexOf(item.extraId);

      if (index !== -1) {
        filter.splice(index, 1);
      }
    }
  };

  vm.filter = function(item) {
    var f_price = rangePrice(item);
    var f_passengers = rangePassengers(item);
    var f_suitcases = rangeSuitcases(item);
    var category = filterByCategory(item);
    var pack = vm.isDisposition ? filterByPack(item) : true;
    var pax = vm.isDisposition ? filterByDispositionPax(item) : true;

    return f_price && f_passengers && f_suitcases && category && pack && pax;
  };

  vm.getFilteredLists = function() {
    return $filter("filter")(vm.lists || [], vm.filter);
  };

  vm.getTotalPages = function() {
    var totalItems = vm.getFilteredLists().length;
    return Math.max(1, Math.ceil(totalItems / vm.pageSize));
  };

  vm.getPageNumbers = function() {
    return Array.from({ length: vm.getTotalPages() }, function(_, index) {
      return index + 1;
    });
  };

  vm.getPaginatedLists = function() {
    var filteredLists = vm.getFilteredLists();
    var totalPages = vm.getTotalPages();

    if (vm.currentPage > totalPages) {
      vm.currentPage = totalPages;
    }

    var start = (vm.currentPage - 1) * vm.pageSize;
    return filteredLists.slice(start, start + vm.pageSize);
  };

  vm.goToPage = function(page, event) {
    if (event) {
      event.preventDefault();
    }
    if (page < 1 || page > vm.getTotalPages()) {
      return;
    }
    vm.currentPage = page;
    goSectionList();
  };

  vm.nextPage = function(event) {
    vm.goToPage(vm.currentPage + 1, event);
  };

  vm.previousPage = function(event) {
    vm.goToPage(vm.currentPage - 1, event);
  };

  vm.getGlobalIndex = function(localIndex) {
    return (vm.currentPage - 1) * vm.pageSize + localIndex;
  };

  vm.pageChanged = function() {
    if (vm.currentPage < 1) {
      vm.currentPage = 1;
      return;
    }

    if (vm.currentPage > vm.getTotalPages()) {
      vm.currentPage = vm.getTotalPages();
    }

    goSectionList();
  };

  vm.sendBy = function(_transport, type) {
    switch (type) {
      case "copy":
        byCopy();
        break;
      case "wa":
        byWA(_transport);
        break;
      case "email":
        byEmail(_transport);
        break;
    }
  };

  vm.sendEmail = function(_transport) {
    // console.log(_transport);
    var box = window.__mt.setting.box;
    var params = {
      email: vm.email_offer,
      data: {
        adults: box.adults,
        arrival_date: box.arrival_date,
        arrival_lat: box.arrival_lat,
        arrival_lng: box.arrival_lng,
        children: box.children,
        departure_date: box.departure_date,
        departure_lat: box.departure_lat,
        departure_lng: box.departure_lng,
        infants: box.infants,
        transfer_type: box.transfer_type,
        lang: window.__mt.ln.lang,
        arrival_type: box.arrival_type,
        departure_type: box.departure_type,
        from: box.from,
        to: box.to,
        referrer: getUserIdPost(),
      },
      transport: transportEmail,
    };

    $http
      .post(window.__mt.setting.api_email, params)
      .then(console.log, console.log);
    $("#modal_offer").modal("hide");
  };

  vm.getIconExtra = function(name) {
    return name
      .replace(/\s/g, "")
      .replace(/&/g, "")
      .toLowerCase();
  };

  vm.showBanner = function(position) {
    if (position == 0) {
      return false;
    }
    return position % 3 == 0;
  };

  vm.openFilters = function(t) {
    if (t == "open") {
      $("#c-filters").show();
    }

    if (t == "close") {
      $("#c-filters").hide();
    }
  };

  vm.getDiscount = function(list) {
    let percent = 1 + list.promotionPercent / 100;
    let price = list.price;
    let total = price * percent * vm.convertion;
    return $filter("currency")(total, vm.ln.currency_code);
  };

  vm.showMeetGreetMessage = function(is_meet, meet) {
    if (is_meet) {
      return meet;
    }
    return true;
  };

  function byWA(_transport) {
    var box = window.__mt.setting.box;
    var params = {
      adults: box.adults,
      arrival_date: box.arrival_date,
      arrival_lat: box.arrival_lat,
      arrival_lng: box.arrival_lng,
      children: box.children,
      departure_date: box.departure_date,
      departure_lat: box.departure_lat,
      departure_lng: box.departure_lng,
      infants: box.infants,
      transfer_type: box.transfer_type,
      lang: window.__mt.ln.lang,
      arrival_type: box.arrival_type,
      departure_type: box.departure_type,
      from: box.from,
      to: box.to,
      client_api_key: box.client_api_key ?? "",
      referrer: getUserIdPost(),
    };

    var url =
      window.__mt.setting.search_page + "?" + window.__mt.fn.encodeUrl(params);
    $http
      .post(window.__mt.setting.api_urlshort, {
        url: url,
      })
      .then((data) => {
        var text = window.__mt.ln.send_by + " \n " + data.data.url;
        window.open(
          window.__mt.setting.whatsapp +
            "?text=" +
            window.encodeURIComponent(text),
          "_target"
        );
      });
  }

  function byCopy() {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        vm.copy = true;
        $scope.$apply();
      })
      .catch((err) => {
        vm.copy = false;
        $scope.$apply();
      });
  }

  function byEmail(_transport) {
    $("#modal_offer").modal("show");
    transportEmail = _transport;
  }

  function rangePrice(item) {
    var MAX_PRICE = vm.filter_setting.price.max + 1;
    var MIN_PRICE = vm.filter_setting.price.min - 1;
    var ticket = item.price;

    return ticket >= MIN_PRICE && ticket <= MAX_PRICE;
  }

  function rangePassengers(item) {
    //var MAX = vm.filter_setting.passengers.max + 1;
    var MIN = vm.filter_setting.passengers.min;
    var ticket_min = item.minPassengers;
    var ticket_max = item.maxPassengers;

    return ticket_max >= MIN;
  }

  function rangeSuitcases(item) {
    var MAX = vm.filter_setting.suitcases.max + 1;
    var MIN = vm.filter_setting.suitcases.min - 1;
    var ticket = item.suitcases;

    return ticket >= MIN && ticket <= MAX;
  }

  function filterByCategory(item) {
    var length = filter.length;
    if (!length) {
      return true;
    }
    var result = $filter("filter")(item.extras, filterCategory);

    return result && result.length;
  }

  function filterCategory(item) {
    return filter.indexOf(item.extraId) !== -1;
  }

  function filterByPack(item) {
    if (!vm.dispositionPack) return true;
    return item.pack === vm.dispositionPack;
  }

  function filterByDispositionPax(item) {
    if (!vm.dispositionPax) return true;
    return item.maxPassengers >= vm.dispositionPax;
  }

  function getTransports(url = false) {
    var user = __mt.setting.user || {};
    var box = window.__mt.setting.box;
    var params = {
      params: {
        adults: box.adults,
        arrival_date: box.arrival_date,
        arrival_time: box.arrival_time,
        arrival_lat: box.arrival_lat,
        arrival_lng: box.arrival_lng,
        children: box.children,
        departure_date: box.departure_date,
        departure_time: box.departure_time,
        departure_lat: box.departure_lat,
        departure_lng: box.departure_lng,
        infants: box.infants,
        type: box.transfer_type,
        lang: window.__mt.ln.lang,
        transfer: box.transfer,
        user_id: user.id,
        user_type: user.type,
        origin: box.from,
        destination: box.to,
        client_api_key: box.client_api_key ?? "",
        coupon: box.coupon ?? "",
      },
    };    // Use disposition API if disposition mode is active
    var isDisposition = box.disposition === true || box.disposition === 'true' || box.disposition === '1';
    if (isDisposition && window.__mt.setting.disposition_active) {
      params.params.hours = parseInt(box.hours) || 1;
      params.params.returnDate = box.departure_date || '';
      $http.get(window.__mt.setting.api_disposition_list, params).then(onResponse, onError);
    } else {
      $http.get(window.__mt.setting.api_list, params).then(onResponse, onError);
    }
  }

  vm.getTransportWithUrl = function() {
    if (vm.no_result_next_url) {
      $http.get(vm.no_result_next_url, params).then(onResponse, onError);
    }
  };
  function buildDispositionFilter(list) {
    if (!list || !list.length) {
      return { prices: { min: 0, max: 9999 }, passengers: { min: 0, max: 99 }, suitcases: { min: 0, max: 99 } };
    }
    var prices     = list.map(function(i) { return i.price || 0; });
    var passengers = list.map(function(i) { return i.maxPassengers || 0; });
    var suitcases  = list.map(function(i) { return i.suitcases || 0; });
    return {
      prices:     { min: Math.min.apply(null, prices),     max: Math.max.apply(null, prices) },
      passengers: { min: Math.min.apply(null, passengers), max: Math.max.apply(null, passengers) },
      suitcases:  { min: Math.min.apply(null, suitcases),  max: Math.max.apply(null, suitcases) },
    };
  }

  function onResponse(data) {
    _response = data.data;
    if (_response.code == 200 && _response.response.transferPriceList) {
      vm.lists = _response.response.transferPriceList || [];
      vm.originalLists = [...vm.lists];
      vm.currentPage = 1;
      window.__mt.list = _response.response;

      // Si la respuesta no trae filtros (ej. disposición), construirlos desde la lista
      if (!_response.filter) {
        _response.filter = buildDispositionFilter(vm.lists);
      }

      initVarFilter(_response);
      goSectionList();
      getDistance();
      initSlider();
      datalayerViewItemList();
      $timeout(() => {
        initToogle();
      }, 2000);
    } else {
      vm.lists = [];
      vm.no_results = true;
      vm.no_results_service = _response.destinationNotOperated;
      vm.no_results_availability = _response.noAvailability;
      vm.no_result_next_date = _response.nextAvailableDate;
      vm.no_result_next_url = _response.nextAvailableUrl;
      initNoResultMap();
      goNoResults();
    }

    vm.loading = false;
  }

  function onError(data) {
    vm.loading = false;
    vm.lists = [];
    vm.no_results = true;
    initNoResultMap();
    goNoResults();
  }

  function setText() {
    var box = window.__mt.setting.box || {};
    var text = (box.from || "") + " | " + (box.arrival_date || "");
    var text_dropoff =
      (box.to || "") +
      (box.transfer_type == "roundtrip"
        ? " | " + (box.departure_date || "")
        : "");

    // Para el botón móvil
    var isDisposition = box.disposition === true || box.disposition === 'true' || box.disposition === '1';
    var textDestination = isDisposition
      ? (box.from || "Select pickup")
      : (box.from || "Select pickup") + " - " + (box.to || "Select destination");
    vm.dateRange = formatDateRange(box);

    vm.destinationName = textDestination.substring(0, 50).concat("...");

    $("#list-pickup").html(text);
    $("#list-dropoff").html(text_dropoff);
  }

  function getTimeFormat(time) {
    var t = "";
    try {
      var hour = time.substring(0, 2);
      var minute = time.substring(2, 4);
      t = hour + ":" + minute + " hrs";
    } catch (error) {
      t = "";
    }
    return t;
  }

  function initToogle() {
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
          panel.style.display = "none";
        } else {
          panel.style.display = "block";
        }
      });
    }
  }

  function isValidRequest() {
    var valid = false;
    if (window.__mt.setting.box) {
      if (
        window.__mt.setting.box.adults &&
        window.__mt.setting.box.arrival_date &&
        window.__mt.setting.box.transfer_type
      ) {
        valid = true;
        vm.box = window.__mt.setting.box || {};
        vm.isDisposition = vm.box.disposition === true || vm.box.disposition === 'true' || vm.box.disposition === '1';
        vm.rountrip =
          window.__mt.setting.box.transfer_type == "roundtrip" ? 2 : 1;
      }
    }

    return valid;
  }

  function initNoResultMap() {
    vm.showNoResultsMap = true;
    id_map = document.getElementById("map-no-results");
    if (!map && !window.google) {
      window.__mt.fn.getScript(
        window.__mt.setting.google_map,
        {},
        loadMapNoResults
      );
    } else {
      onLoaloadMapNoResultsMap();
    }
  }

  function onLoadMap() {
    var data = window.__mt.setting.box;
    var isDisp = data.disposition === true || data.disposition === 'true' || data.disposition === '1';

    if (data.arrival_lat && data.arrival_lng) {
      var options = {
        center: {
          lat: +data.arrival_lat,
          lng: +data.arrival_lng,
        },
        disableDefaultUI: true,
      };

      map = new google.maps.Map(id_map, options);

      var pointA = {
        lat: +data.arrival_lat,
        lng: +data.arrival_lng,
      };

      if (isDisp) {
        new google.maps.Marker({ position: pointA, map: map, draggable: false });
      } else if (data.departure_lat && data.departure_lng) {
        var pointB = {
          lat: +data.departure_lat,
          lng: +data.departure_lng,
        };
        var directionsService = new google.maps.DirectionsService();
        var directionsDisplay = new google.maps.DirectionsRenderer();
        directionsDisplay.setMap(map);
        window.__mt.fn.createRoute(pointA, pointB, map, directionsService, directionsDisplay);
      }
    }
  }

  function loadMapNoResults() {
    var data = window.__mt.setting.box;
    var isDisp = data.disposition === true || data.disposition === 'true' || data.disposition === '1';

    if (data.arrival_lat && data.arrival_lng && (isDisp || (data.departure_lat && data.departure_lng))) {
      var mapOptions = {
        center: new google.maps.LatLng(+data.arrival_lat, +data.arrival_lng),
        zoom: 6,
        treetViewControl: false,
        mapTypeControl: false,
        disableDefaultUI: true,
      };

      map = new google.maps.Map(id_map, mapOptions);

      var markera = new google.maps.Marker({
        position: new google.maps.LatLng(+data.arrival_lat, +data.arrival_lng),
        draggable: false,
      });
      markera.setMap(map);

      if (!isDisp) {
        var markerb = new google.maps.Marker({
          position: new google.maps.LatLng(+data.departure_lat, +data.departure_lng),
          draggable: false,
        });
        markerb.setMap(map);

        var bounds = new google.maps.LatLngBounds();
        bounds.extend(markera.getPosition());
        bounds.extend(markerb.getPosition());
        map.setCenter(bounds.getCenter());
        map.fitBounds(bounds);
      }
    }
  }

  function goSectionList() {
    var offset = -20;
    $("html, body").animate(
      {
        scrollTop: $("#section_list").offset().top + offset,
      },
      500
    );
  }

  function goNoResults() {
    var offset = -100;
    $timeout(() => {
      $("html, body").animate(
        {
          scrollTop: $("#no-results").offset().top + offset,
        },
        500
      );
    }, 700);
  }

  function getDistance() {
    var quote = window.__mt.setting.box;

    origin = quote.arrival_lat + "," + quote.arrival_lng;
    destination = quote.departure_lat + "," + quote.departure_lng;
    var distance = localStorageService.get("distance");

    if (
      distance &&
      distance.data &&
      distance.origin == origin &&
      distance.destination == destination
    ) {
      _distance = distance;
      setDistance();
      return;
    }

    var params = {
      params: {
        origins: origin,
        destinations: destination,
      },
    };
    $http
      .get(window.__mt.setting.api_distance, params)
      .then(onSuccessDistance, console.log);
  }

  function setDistance() {
    if (_distance) {
      if (_distance.data && _distance.data.rows && _distance.data.rows.length) {
        vm.distance = _distance.data.rows[0].elements.length
          ? _distance.data.rows[0].elements[0]
          : vm.distance;
      }
    }
  }

  function onSuccessDistance(data) {
    var response = data.data;
    if (response.status == "OK") {
      var distance = {};
      distance.data = response;
      distance.origin = origin;
      distance.destination = destination;
      localStorageService.set("distance", distance);
      _distance = distance;
      setDistance();
    }
  }

  function initVarFilter(_response) {
    vm.filters = _response.filter || {};
    if (_response.filter) {
      vm.filter_setting.price.min = _response.filter.prices.min;
      vm.filter_setting.price.max = _response.filter.prices.max;

      vm.filter_setting.passengers.min = _response.filter.passengers.min;
      vm.filter_setting.passengers.max = _response.filter.passengers.max;

      vm.filter_setting.suitcases.min = _response.filter.suitcases.min;
      vm.filter_setting.suitcases.max = _response.filter.suitcases.max;
    }
  }

  function initSlider() {
    if (vm.filters && vm.filters.prices) {
      vm.sliders = {
        price: new Slider("#prices", {
          min: vm.filters.prices.min,
          max: vm.filters.prices.max,
          value: [vm.filters.prices.min, vm.filters.prices.max],
        }),
        passengers: new Slider("#passengers_list", {
          min: vm.filters.passengers.min,
          max: vm.filters.passengers.max,
          value: vm.filters.passengers.min,
        }),
        suitcases: new Slider("#suitcases_list", {
          min: vm.filters.suitcases.min,
          max: vm.filters.suitcases.max,
          value: [vm.filters.suitcases.min, vm.filters.suitcases.max],
        }),
        price_1: new Slider("#prices_1", {
          min: vm.filters.prices.min,
          max: vm.filters.prices.max,
          value: [vm.filters.prices.min, vm.filters.prices.max],
        }),
        passengers_1: new Slider("#passengers_list_1", {
          min: vm.filters.passengers.min,
          max: vm.filters.passengers.max,
          value: vm.filters.passengers.min,
        }),
        suitcases_1: new Slider("#suitcases_list_1", {
          min: vm.filters.suitcases.min,
          max: vm.filters.suitcases.max,
          value: [vm.filters.suitcases.min, vm.filters.suitcases.max],
        }),
      };

      vm.tempValues = {
        price: {
          min: vm.filters.prices.min,
          max: vm.filters.prices.max,
        },
        passengers: {
          min: vm.filters.passengers.min,
        },
        suitcases: {
          min: vm.filters.suitcases.min,
          max: vm.filters.suitcases.max,
        },
      };

      vm.sliders.price.on("slide", function(values) {
        $scope.$apply(function() {
          vm.tempValues.price = {
            min: values[0],
            max: values[1],
          };
        });
      });

      vm.sliders.price.on("slideStop", function(values) {
        $scope.$apply(function() {
          vm.tempValues.price = {
            min: values[0],
            max: values[1],
          };
        });
      });

      vm.sliders.passengers.on("slide", function(values) {
        $scope.$apply(function() {
          vm.tempValues.passengers.min = values;
        });
      });

      vm.sliders.passengers.on("slideStop", function(values) {
        $scope.$apply(function() {
          vm.tempValues.passengers.min = values;
        });
      });

      vm.sliders.suitcases.on("slide", function(values) {
        $scope.$apply(function() {
          vm.tempValues.suitcases = {
            min: values[0],
            max: values[1],
          };
        });
      });

      vm.sliders.suitcases.on("slideStop", function(values) {
        $scope.$apply(function() {
          vm.tempValues.suitcases = {
            min: values[0],
            max: values[1],
          };
        });
      });
    }
  }

  function datalayerViewItemList() {
    try {
      analyticsService.viewItemList(window.__mt.list, config.box);
    } catch (error) {
      console.log(error);
    }
  }

  // filters
  vm.onChangeRangePrice = function(values) {
    var min = values[0] || vm.filters.prices.min;
    var max = values[1] || vm.filters.prices.max;
    vm.filter_setting.price.min = min;
    vm.filter_setting.price.max = max;

    vm.filtersApplied.price =
      min !== vm.filters.prices.min || max !== vm.filters.prices.max;
    vm.updateFilterStatus();
    vm.currentPage = 1;
  };

  vm.onChangeRangePassengers = function(values) {
    var min = values || vm.filters.passengers.min;
    vm.filter_setting.passengers.min = min;

    vm.filtersApplied.passengers = min !== vm.filters.passengers.min;
    vm.updateFilterStatus();
    vm.currentPage = 1;
  };

  vm.onChangeRangeSuitcases = function(values) {
    var min = values[0] || vm.filters.suitcases.min;
    var max = values[1] || vm.filters.suitcases.max;
    vm.filter_setting.suitcases.min = min;
    vm.filter_setting.suitcases.max = max;

    vm.filtersApplied.suitcases =
      min !== vm.filters.suitcases.min || max !== vm.filters.suitcases.max;
    vm.updateFilterStatus();
    vm.currentPage = 1;
  };

  vm.applyAllFilters = function() {
    if (vm.sliders) {
      if (vm.sliders.price_1) {
        var priceValues = vm.sliders.price_1.getValue();
        vm.syncSliders("price", priceValues);
        vm.onChangeRangePrice(priceValues);
      }
      if (vm.sliders.passengers_1) {
        var passengersValues = vm.sliders.passengers_1.getValue();
        vm.syncSliders("passengers", passengersValues);
        vm.onChangeRangePassengers(passengersValues);
      }
      if (vm.sliders.suitcases_1) {
        var suitcasesValues = vm.sliders.suitcases_1.getValue();
        vm.syncSliders("suitcases", suitcasesValues);
        vm.onChangeRangeSuitcases(suitcasesValues);
      }
    }

    vm.filtersApplied.extras = filter.length > 0;
    vm.updateFilterStatus();
    vm.closeDropdown();
  };

  vm.applyPriceFilter = function() {
    if (vm.sliders && vm.sliders.price) {
      var values = vm.sliders.price.getValue();
      vm.syncSliders("price", values);
      if (vm.tempValues && vm.tempValues.price) {
        vm.onChangeRangePrice([
          vm.tempValues.price.min,
          vm.tempValues.price.max,
        ]);
      }
    }
    vm.closeDropdown();
  };

  vm.applyPassengersFilter = function() {
    if (vm.sliders && vm.sliders.passengers) {
      var values = vm.sliders.passengers.getValue();
      vm.syncSliders("passengers", values);
      if (vm.tempValues && vm.tempValues.passengers) {
        vm.onChangeRangePassengers(vm.tempValues.passengers.min);
      }
    }
    vm.closeDropdown();
    vm.filterJustApplied = true;
    $timeout(function() {
      vm.filterJustApplied = false;
    }, 1000);
  };

  vm.applySuitcasesFilter = function() {
    if (vm.sliders && vm.sliders.suitcases) {
      var values = vm.sliders.suitcases.getValue();
      vm.syncSliders("suitcases", values);
      vm.onChangeRangeSuitcases(values);
    }
    vm.closeDropdown();
  };

  vm.applyExtrasFilter = function() {
    vm.filtersApplied.extras = filter.length > 0;
    vm.updateFilterStatus();
    vm.currentPage = 1;
    vm.closeDropdown();
  };

  vm.updateFilterStatus = function() {
    vm.hasActiveFilters =
      vm.filtersApplied.price ||
      vm.filtersApplied.passengers ||
      vm.filtersApplied.suitcases ||
      vm.filtersApplied.extras ||
      vm.filtersApplied.sort ||
      vm.filtersApplied.pack ||
      vm.filtersApplied.pax;
  };

  vm.syncSliders = function(type, values) {
    if (!vm.sliders) return;

    switch (type) {
      case "price":
        if (vm.sliders.price && vm.sliders.price_1) {
          vm.sliders.price.setValue(values);
          vm.sliders.price_1.setValue(values);
        }
        break;
      case "passengers":
        if (vm.sliders.passengers && vm.sliders.passengers_1) {
          vm.sliders.passengers.setValue(values);
          vm.sliders.passengers_1.setValue(values);
        }
        break;
      case "suitcases":
        if (vm.sliders.suitcases && vm.sliders.suitcases_1) {
          vm.sliders.suitcases.setValue(values);
          vm.sliders.suitcases_1.setValue(values);
        }
        break;
    }
  };

  vm.clearPriceFilter = function() {
    vm.filter_setting.price.min = vm.filters.prices.min;
    vm.filter_setting.price.max = vm.filters.prices.max;

    vm.tempValues.price = {
      min: vm.filters.prices.min,
      max: vm.filters.prices.max,
    };

    if (vm.sliders) {
      var defaultValues = [vm.filters.prices.min, vm.filters.prices.max];
      if (vm.sliders.price) vm.sliders.price.setValue(defaultValues);
      if (vm.sliders.price_1) vm.sliders.price_1.setValue(defaultValues);
    }

    vm.filtersApplied.price = false;
    vm.updateFilterStatus();
    vm.currentPage = 1;
  };

  vm.clearPassengersFilter = function() {
    vm.filter_setting.passengers.min = vm.filters.passengers.min;

    vm.tempValues.passengers = {
      min: vm.filters.passengers.min,
    };

    if (vm.sliders) {
      var defaultValue = vm.filters.passengers.min;
      if (vm.sliders.passengers) vm.sliders.passengers.setValue(defaultValue);
      if (vm.sliders.passengers_1)
        vm.sliders.passengers_1.setValue(defaultValue);
    }

    vm.filtersApplied.passengers = false;
    vm.updateFilterStatus();
    vm.currentPage = 1;
  };

  vm.clearSuitcasesFilter = function() {
    vm.filter_setting.suitcases.min = vm.filters.suitcases.min;
    vm.filter_setting.suitcases.max = vm.filters.suitcases.max;

    vm.tempValues.suitcases = {
      min: vm.filters.suitcases.min,
      max: vm.filters.suitcases.max,
    };

    if (vm.sliders) {
      var defaultValues = [vm.filters.suitcases.min, vm.filters.suitcases.max];
      if (vm.sliders.suitcases) vm.sliders.suitcases.setValue(defaultValues);
      if (vm.sliders.suitcases_1)
        vm.sliders.suitcases_1.setValue(defaultValues);
    }

    vm.filtersApplied.suitcases = false;
    vm.updateFilterStatus();
    vm.currentPage = 1;
  };

  vm.clearExtrasFilter = function() {
    filter.length = 0;

    if (vm.filters.extras) {
      vm.filters.extras.forEach(function(extra) {
        extra.active = false;
      });
    }

    vm.filtersApplied.extras = false;
    vm.updateFilterStatus();
    vm.currentPage = 1;
  };

  vm.clearSortFilter = function() {
    vm.sortBy("recommended");
    var firstLinkText = $("#dropdown-menu-1 a.dropdown-item")
      .first()
      .text()
      .trim();
    $("#recommended-text").text(firstLinkText);
  };

  vm.clearAllFilters = function() {
    vm.tempValues = {
      price: {
        min: vm.filters.prices.min,
        max: vm.filters.prices.max,
      },
      passengers: {
        min: vm.filters.passengers.min,
      },
      suitcases: {
        min: vm.filters.suitcases.min,
        max: vm.filters.suitcases.max,
      },
    };

    vm.clearPriceFilter();
    vm.clearPassengersFilter();
    vm.clearSuitcasesFilter();
    vm.clearExtrasFilter();
    vm.sortBy();
    vm.dispositionPack = null;
    vm.dispositionPax = null;
    vm.filtersApplied.pack = false;
    vm.filtersApplied.pax = false;
    vm.currentPage = 1;
  };

  vm.setDispositionPack = function(pack) {
    vm.dispositionPack = vm.dispositionPack === pack ? null : pack;
    vm.filtersApplied.pack = vm.dispositionPack !== null;
    vm.updateFilterStatus();
    vm.currentPage = 1;
  };

  vm.setDispositionPax = function(pax) {
    vm.dispositionPax = vm.dispositionPax === pax ? null : pax;
    vm.filtersApplied.pax = vm.dispositionPax !== null;
    vm.updateFilterStatus();
    vm.currentPage = 1;
  };

  vm.clearDispositionPack = function() {
    vm.dispositionPack = null;
    vm.filtersApplied.pack = false;
    vm.updateFilterStatus();
    vm.currentPage = 1;
  };

  vm.clearDispositionPax = function() {
    vm.dispositionPax = null;
    vm.filtersApplied.pax = false;
    vm.updateFilterStatus();
    vm.currentPage = 1;
  };

  // end filters

  function GoogleAddToCart(item, index) {
    try {
      localStorageService.set("ga_index", index + 1);
      ListAnalytic.setAddToCart(window.__mt.list, item, index + 1, config.box);
      ListAnalyticV1.setAddToCart(window.__mt.list, item, index);
    } catch (error) {
      console.log(error);
    }
  }

  function getUserIdPost() {
    var user = __mt.setting.user || {};
    var user_id = null;
    if (user.type == "agency" && user.agency) {
      user_id = user.agency.mypost_id;
    }

    return user_id;
  }

  vm.sortBy = function(criteria) {
    switch (criteria) {
      case "recommended":
        if (vm.originalLists) {
          vm.lists = [...vm.originalLists];
        }
        vm.filtersApplied.sort = false;
        break;
      case "lowest":
        vm.lists.sort((a, b) => a.price - b.price);
        vm.filtersApplied.sort = true;
        break;
      case "highest":
        vm.lists.sort((a, b) => b.price - a.price);
        vm.filtersApplied.sort = true;
        break;
      case "capacity":
        vm.lists.sort((a, b) => b.maxPassengers - a.maxPassengers);
        vm.filtersApplied.sort = true;
        break;
      default:
        break;
    }

    // Cerrar dropdown
    vm.currentPage = 1;
    vm.closeDropdown();
  };

  vm.isMobile = function() {
    return window.innerWidth < 992;
  };

  vm.mobileCheckout = function(list, index) {
    if (vm.isMobile()) {
      vm.checkout(list, index);
    }
  };

  vm.openSuitcasesModal = function($event) {
    $event.stopPropagation();
    $("#c-modal-suitcases").modal("show");
  };

  vm.closeDropdown = function() {
    // Cerrar todos los dropdowns usando jQuery básico
    $(".dropdown-menu-custom").removeClass("show");
    $(".dropdown-toggle-custom").removeClass("show active");
  };

  vm.shareModal = function(vehicle, index) {
    vm.selectedVehicle = vehicle;
    vm.selectedIndex = index;
  };

  vm.toggleInfoTooltip = function($event, index) {
    $event.preventDefault();
    $event.stopPropagation();
    vm.activeInfoTooltip = vm.activeInfoTooltip === index ? null : index;
  };

  $(document).on("click.infoTooltip", function(e) {
    if (vm.activeInfoTooltip !== null && !$(e.target).closest(".tooltip-container").length) {
      vm.activeInfoTooltip = null;
      $scope.$apply();
    }
  });

  $scope.$on("$destroy", function() {
    $(document).off("click.infoTooltip");
  });

  function formatDateRange(box) {
    if (!box.arrival_date) return "Select dates";

    let arrivalDate = new Date(box.arrival_date);
    let dateStr = arrivalDate.toLocaleDateString("en-EN", {
      weekday: "short",
      day: "numeric",
      month: "short",
    });

    let timeStr = box.arrival_time
      ? box.arrival_time.substring(0, 5)
      : (box.arrival_date && box.arrival_date.includes(' ')
          ? box.arrival_date.split(' ')[1].substring(0, 5)
          : "15:30");

    if (box.disposition === true || box.disposition === 'true' || box.disposition === '1') {
      let hours = parseInt(box.hours) || 1;
      return `${dateStr}, ${timeStr} · ${hours}h`;
    }

    if (box.transfer_type === "roundtrip" && box.departure_date) {
      let departureDate = new Date(box.departure_date);
      let depDateStr = departureDate.toLocaleDateString("en-EN", {
        weekday: "short",
        day: "numeric",
        month: "short",
      });
      let depTimeStr = box.departure_time
        ? box.departure_time.substring(0, 5)
        : (box.departure_date && box.departure_date.includes(' ')
            ? box.departure_date.split(' ')[1].substring(0, 5)
            : "12:00");
      return `${dateStr}, ${timeStr} - ${depDateStr}, ${depTimeStr}`;
    }

    return `${dateStr}, ${timeStr}`;
  }

  vm.getTotalPassengers = function() {
    var box = window.__mt.setting.box || {};
    var adults = parseInt(box.adults) || 0;
    var children = parseInt(box.children) || 0;
    var infants = parseInt(box.infants) || 0;

    return adults + children + infants;
  };
}
